<template>
  <div style="width: 100%; min-height: 100vh;background: #f1f1f1"">
    <van-nav-bar style="position: fixed; transform: translate(-50%); top: 0; left: 50%; width: 100%;max-width: 412px; background-color: #fff" title="消息中心" left-arrow @click-left="$router.back()" />
      <div style="height: 46px"></div>
    <div class="van-tabs-view van-tabs">
      <div class="van-tabs__wrap">
        <div role="tablist" class="van-tabs__nav van-tabs__nav--card">
          <div role="tab" @click="changType(1)" aria-selected="true" :class="type == 1 ? 'van-tab van-tab--active' : 'van-tab'"><span class="van-tab__text van-tab__text--ellipsis">公告</span></div>
          <div role="tab" @click="changType(2)" :class="type == 2 ? 'van-tab van-tab--active' : 'van-tab'">
            <span class="van-tab__text van-tab__text--ellipsis"><span>站内信</span></span>
          </div>
        </div>
      </div>
      <div class="van-tabs__content" style="width: 90%; margin: 0 auto">
        <div v-if="type == 1" role="tabpanel" class="van-tab__pane" style="">
          <van-list finished-text="没有更多了" :finished="true" v-if="announcements.length > 0">
            <div v-for="(item, index) in announcements" :key="index" class="announcement-item" @click="toggleAnnouncement(item.id)">
              <div class="announcement-header">
                <span class="announcement-title">{{ item.name }}</span>
                <span class="announcement-time">{{ formatDate(item.created_at) }}</span>
              </div>
              <div v-if="expandedAnnouncementId === item.id" class="announcement-content" v-html="item.content"></div>
            </div>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">没有更多了~</van-divider>
        </div>
        <div v-if="type == 2" role="tabpanel" class="van-tab__pane">
          <van-list finished-text="没有更多了" offset="300" v-model="loading" :finished="noticeList.length >= noticeListInfo.total" @load="getDatalist" v-if="noticeList.length > 0">
            <div v-for="(item, index) in noticeList" :key="index" class="announcement-item" @click="toggleNotice(item.id)">
              <div class="announcement-header">
                <span class="announcement-title">{{ item.title }}</span>
                <span class="announcement-time">{{ formatDate(item.created_at) }}</span>
              </div>
              <div v-if="expandedNoticeId === item.id" class="announcement-content" v-html="item.content"></div>
            </div>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">没有更多了~</van-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'message',
  data() {
    return { 
        type: 1, 
        noticeList: [], 
        announcements: [],
        expandedAnnouncementId: null,
        expandedNoticeId: null,
        noticeListInfo: {}, 
        page: 1,
        loading: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }

    that.getAnnouncements();
    that.getDatalist();
  },
  methods: {
    changType(type) {
      let that = this;
      that.type = type;
    },
    getAnnouncements() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/homecontent', {})
        .then(res => {
          if (res.code === 200) {
            that.announcements = res.data;
          } else {
            that.$parent.showTost(0, res.message || '获取公告失败');
          }
          that.$parent.hideLoading();
        })
        .catch(err => {
          console.error("Error fetching announcements:", err);
          that.$parent.showTost(0, '获取公告异常');
          that.$parent.hideLoading();
        });
    },
    toggleAnnouncement(id) {
      if (this.expandedAnnouncementId === id) {
        this.expandedAnnouncementId = null;
      } else {
        this.expandedAnnouncementId = id;
      }
    },
    toggleNotice(id) {
      if (this.expandedNoticeId === id) {
        this.expandedNoticeId = null;
      } else {
        this.expandedNoticeId = id;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      if (page > that.noticeListInfo.last_page) {
        that.loading = false;
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeListInfo = res.data;
            if (page == 1) {
              that.noticeList = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list4));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.noticeList = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.van-tabs__nav--card .van-tab.van-tab--active {
    color: #866638;
    background-color: initial;
    border-bottom: 2px solid #866638;
    font-size: 16px;
}
.van-tabs__nav--card {
    border: 1px solid #fff;
}
.van-tab__text{
  font-size: 12px;
  span{
  font-size: 12px;

  }
}
.van-tabs__nav--card .van-tab{
    color: #666;
    font-weight: bold;
}
.van-tabs__nav--card .van-tab{
  border-right: 0 solid #866638;
}

.announcement-item {
    padding: 10px 5px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
}

.announcement-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.announcement-title {
    font-weight: bold;
    color: #333;
    flex-grow: 1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.announcement-time {
    font-size: 12px;
    color: #999;
    flex-shrink: 0;
}

.announcement-content {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    ::v-deep p {
        margin-bottom: 8px;
    }
     ::v-deep strong {
        font-weight: bold;
     }
}
.van-tab{
  flex: initial;
  margin-right: 20px;
}
.van-tabs__wrap{
  margin-bottom: 10px;
}
.van-tabs__nav{
  border-top: 1px solid #666;
  margin: 0;
  padding: 0 20px;
  height: 45px;
}
.van-tabs__content{
  background: #fff;
  width: 94%!important;
  border-radius: 6px;
  padding: 10px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/message.vue